// Copyright (c) 2026 Yunus YILDIZ — SPDX-License-Identifier: BUSL-1.1

import { env } from './env'

export const API_BASE_URL = env.VITE_API_URL

export const API_TIMEOUT = 30_000

export const API_DEFAULTS = {
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
}
